import { createApp } from 'vue'
import App from './App.vue'
import { registerPlugins } from './plugins'
import DropDown from './components/DropDown.vue'
import store from '@/store'
import { Chart } from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { initializeApp } from "firebase/app";
import CKEditor from '@ckeditor/ckeditor5-vue';
import favicon from '@/assets/img/favicon.png'

import 'bootstrap/dist/js/bootstrap'
import 'bootstrap/scss/bootstrap.scss'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'
import 'primevue/resources/themes/saga-blue/theme.css'
import '@fortawesome/fontawesome-pro/scss/fontawesome.scss'
import '@fortawesome/fontawesome-pro/scss/brands.scss'
import '@fortawesome/fontawesome-pro/scss/solid.scss'
import '@fortawesome/fontawesome-pro/scss/regular.scss'
import '@fortawesome/fontawesome-pro/scss/light.scss'
import '@/assets/styles/theme.scss'
import '@/assets/styles/flags.css'

const firebaseConfig = {
    apiKey: "AIzaSyBivWYTqzUB5Xyb_i_8GqAIUDXaEBq2Qlk",
    authDomain: "csmb-216007.firebaseapp.com",
    projectId: "csmb-216007",
    storageBucket: "csmb-216007.appspot.com",
    messagingSenderId: "1040777940832",
    appId: "1:1040777940832:web:74c13bfac274cd4d8d9805"
};

initializeApp(firebaseConfig);

const setFavicon = () => {
    let link = document.querySelector("link[rel~='icon']")
    if (!link) {
        link = document.createElement('link')
        link.rel = 'icon'
        document.head.appendChild(link)
    }
    link.href = favicon
}

(async () => {
    setFavicon()
    store.state.auth.token && await store.dispatch('auth/refreshToken')

    Chart.register(ChartDataLabels)
    Chart.defaults.plugins.datalabels.display = ctx => ctx.dataset.data[ctx.dataIndex] !== 0
    
    const app = createApp(App)
    registerPlugins(app)
    app.component('DropDown', DropDown)
    app.use(CKEditor)
    app.directive('focus', {
        mounted(el) {
            el.focus()
        }
    })
    app.mount('#app')
})()
